import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
import { environment } from 'src/environments/environment';
import { DateFormatConst } from '../constant/dateFormat.constant';

@Pipe({
  name: 'dateFormat',
  standalone: true,
})
export class DateFormatPipe implements PipeTransform {
  transform(value: Date, args?: any): unknown {
    if (!value) {
      return '';
    }

    let valueFormat = '';
    let langCode = localStorage.getItem('languageCulture');
    if (!langCode) {
      langCode = environment.defaultLanguage;
    }

    const type = args || DateFormatConst.SHORT_DATE;

    switch (type) {
      case DateFormatConst.LONG_DATE:
        valueFormat = langCode === 'en' ? 'MM/DD/YYYY hh:mm:ss' : 'DD.MM.YYYY hh:mm:ss';
        break;
      default:
        valueFormat = langCode === 'en' ? 'MM/DD/YYYY' : 'DD.MM.YYYY';
        break;
    }

    return moment(value).format(valueFormat);
  }
}
